import React, { Fragment } from 'react';

const NaoEncontrada = () => <Fragment>Não Encontrada.</Fragment>;

export default NaoEncontrada;
